var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shape",class:( _obj = {}, _obj['shape-' + _vm.type] = true, _obj['color-' + _vm.color] = true, _obj['highlight'] =  _vm.highlight, _obj ),style:({ width: _vm.size + 'px', height: _vm.size + 'px' }),on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }